<template>
    <div class="page_box" style="min-height: 600px;background: #f4f4f4;">
        <div class="m-breadcrumbBox f-cb" id="j-breadcrumbBox">
            <div class="g-mn2">
                <div class="g-flow f-cb">
                    <ul class="g-flow">
                        <li class="navcrumb-item" id="navcrumbId-1">
                            <a href="" target="_self">刷新</a>
                        </li>
                        <li class="navcrumb-item" id="navcrumbId-2">
                            <span class="arrow"></span>
                            <a href="javascript:void(0)">课堂直播</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="m2-live" id="j-live-box">
            <div class="mc-live-list" data-log-id="liveList" data-log-data="{&quot;sceneLog&quot;:&quot;直播列表模块&quot;}"
                id="auto-id-1614756050139">
                <div class="j-live-list" id="auto-id-1614756050147">
                    <div class="uc-live-list g-flow" id="auto-id-1614756050146">
                        <div class="live-list-lives" id="auto-id-1614756050145">
                            <div v-for="(item,index) in LiveStreamingList" :key="index" @click="enterLive(item)"
                                class="um-live-live-card z-col-3 liveone">
                                <div class="um-live-live-card-head"><img class="um-live-live-card-head_img"
                                        src="//edu-image.nosdn.127.net/1955309A8422135907B2C61638195059.png?imageView&amp;quality=100&amp;thumbnail=225y225">
                                </div>
                                <div class="um-live-live-card-action z-joining">
                                    <span v-if="item.liveState != 2" class="um-live-live-card-action_label">
                                        <img class="i-ing"
                                            src="//edu-image.nosdn.127.net/0a9c8809-ce4e-4512-90cc-a26324f3e71e.gif?imageView&amp;quality=100">
                                    </span>
                                    <span v-if="item.liveState == 3"
                                        class="um-live-live-card-action_btn ux-icon-caret-right"
                                        style="color: white;">进入直播</span>
                                    <span v-if="item.liveState == 1"
                                        class="um-live-live-card-action_btn ux-icon-caret-right"
                                        style="color: white;">即将开始</span>
                                    <span v-if="item.liveState == 2"
                                        class="um-live-live-card-action_btn ux-icon-caret-right"
                                        style="color: white;">已经结束</span>
                                </div>
                                <div class="um-live-live-card-tit">{{item.chapterName}}-{{item.liveTitle}}</div>
                                <div class="um-live-live-card-subtit">{{item.teacherName}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="liveFlag" style="font-size: 16px;text-align: center;margin-top: 200px;color:lightgray;">暂无直播
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                liveFlag: false,
                LiveStreamingList: []
            }
        },
        created() {
            //查询直播列表
            this.loaddictWorkTypeLiveStreamingCourse();

        },
        mounted() {

        },
        beforeDestroy() {

        },
        methods: {
            enterLive(item) {

                //先判断状态
                if (item.liveState === 1) {
                    this.$message({
                        showClose: true,
                        message: '直播暂未开始！',
                        type: 'warning'
                    })
                    return false;
                } else if (item.liveState === 2) {
                    this.$message({
                        showClose: true,
                        message: '直播已经结束!',
                        type: 'warning'
                    })
                    return false;
                } else {
                    let parames = new URLSearchParams();
                    parames.append('userId',this.$storage.get("declareUser").id);
                    parames.append('trainState',2);
                    parames.append('workTypeId',item.workTypeId);
                    
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/tm/getPower', parames).then(resp => {

                    if (resp.data.code === '4001') {
                        this.$message({
                            showClose: true,
                            message: '请求过于频繁,于一分钟后重试！',
                            type: 'error'
                        })
                    } else if (resp.data.code === '4000' || resp.data.code === '4002' || resp.data.code === '4003') {
                        this.$confirm('登录超时！请重新登录').then(_ => {
                            this.$router.push('/login');
                        }).catch(_ => { });
                    } else {
                        if (resp.data.code === 1) {
                                //正在直播  进入直播
                                let parames = new URLSearchParams();
                                parames.append('streamName', item.streamName);
                                //获取 当前等级下的上传资料 列表
                                this.$axios.post(this.serverUrl + '/livere/GetPlayUrl', parames).then(resp1 => {

                                    console.log(resp1.data.flv)
                                    this.$storage.set('rtm', resp1.data.flv)
                                    console.log(item.courseId)
                                    console.log(item.liveId)
                                    this.$router.push({ path: '/live/'+item.courseId+'/'+item.liveId+'/'+item.courseName});

                                }).catch(err => {
                                    this.$message({
                                        showClose: true,
                                        message: '服务器繁忙，稍后重试！',
                                        type: 'error'
                                    });
                                })

                            } else {

                                this.$message({
                                    showClose: true,
                                    message: '暂无开通该工种下的直播权限！ 请去首页联系方式中联系管理员！',
                                    type: 'warning'
                                })

                            }
                    }
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })
                  
                }



            },
            loaddictWorkTypeLiveStreamingCourse() {
                let parames = new URLSearchParams();

                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/livere/selectLiveList', parames).then(resp => {
                    
                        if (resp.data.code === '1') {
                            let LiveStreamingCourseList = [];
                            for (let i = 0; i < resp.data.data.length; i++) {
                                let LiveStreamingCourseEnter = resp.data.data[i];
                                let LiveStreamingCourseGo = {
                                    liveId: 0,
                                    teacherName: '', //老师名称
                                    workTypeName: '', //工种名称
                                    chapterName: '',
                                    liveState: 0,
                                    workTypeLevelState: '', //工种级别
                                    courseId: '', //课程id
                                    liveTitle: '',
                                    workTypeId:0,
                                    streamName: '', //推流和播流信息通过StreamName字段匹配
                                    livePath: '',
                                    courseName:''
                                };
                                LiveStreamingCourseGo.liveId = LiveStreamingCourseEnter.id;
                                LiveStreamingCourseGo.teacherName = LiveStreamingCourseEnter.teacherName;
                                LiveStreamingCourseGo.workTypeName = LiveStreamingCourseEnter.courseName;
                                LiveStreamingCourseGo.workTypeLevelState = LiveStreamingCourseEnter.coursePeriod;
                                LiveStreamingCourseGo.chapterName = LiveStreamingCourseEnter.chapterName;

                                LiveStreamingCourseGo.liveState = LiveStreamingCourseEnter.liveState;//直播标识1：未开始 3直播中 2已结束
                                LiveStreamingCourseGo.liveTitle = LiveStreamingCourseEnter.liveTitle;
                                LiveStreamingCourseGo.courseId = LiveStreamingCourseEnter.courseId;
                                LiveStreamingCourseGo.streamName = LiveStreamingCourseEnter.streamName;
                                LiveStreamingCourseGo.livePath = LiveStreamingCourseEnter.livePath;
                                LiveStreamingCourseGo.workTypeId = LiveStreamingCourseEnter.workTypeId;

                                LiveStreamingCourseGo.courseName = LiveStreamingCourseEnter.courseName;
                                
                                LiveStreamingCourseList.push(LiveStreamingCourseGo);

                            }

                            this.LiveStreamingList = LiveStreamingCourseList;
                        } else {
                            this.liveFlag = true;
                        }
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })
            }

        }
    }
</script>

<style scoped>
    .uc-live-list .live-list-lives .um-live-live-card .um-live-live-card-tit,
    .uc-live-list .live-list-lives .um-live-live-card .um-live-live-card-subtit {
        width: 100%;
        margin: 0;
        padding: 0 12px;
        box-sizing: border-box;
    }

    .uc-live-list .live-list-lives .um-live-live-card .um-live-live-card-tit {
        font-size: 14px;
        margin: 8px 0;
        line-height: 22px;
        max-height: 44px;
        word-break: break-all;
        position: relative;
        overflow: hidden;
        display: -ms-flexbox;
        display: box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
    }

    .uc-live-list .live-list-lives .um-live-live-card .um-live-live-card-action {
        position: absolute;
        top: 155px;
        width: 100%;
        height: 30px;
        margin: 0;
        background: #fff;
        line-height: 30px;
        padding-left: 12px;
        box-sizing: border-box;
    }

    .uc-live-list .live-list-lives .um-live-live-card .um-live-live-card-action.z-joining,
    .uc-live-list .live-list-lives .um-live-live-card .um-live-live-card-action.z-join {
        background: #49AF4F;
    }

    .uc-live-list .live-list-lives .um-live-live-card .um-live-live-card-head img {
        height: 225px;
        border-radius: 0;
    }

    .uc-live-list .live-list-lives .um-live-live-card .um-live-live-card-head {
        float: none;
        width: 100%;
        height: 185px;
        margin: 0;
        overflow: hidden;
    }

    .um-live-live-card {
        overflow: hidden;
        cursor: pointer;
    }

    .um-live-live-card.z-col-3 {
        display: inline-block;
        padding: 12px;
        margin-right: 24px;
        width: 370px;
        vertical-align: top;
        margin-bottom: 4px;
    }

    .uc-live-list .live-list-lives .um-live-live-card {
        position: relative;
        width: 225px;
        height: 273px;
        padding: 0;
        background: #fff;
        margin-right: 20px;
        margin-bottom: 20px;
    }

    .uc-live-list .live-list-lives {
        width: 1250px;
        margin-top: 32px;
        margin-bottom: 40px;
    }

    .m-live-tab-list .live-list-tab {
        display: inline-block;
        color: #666;
        padding: 2px 5px;
        border-radius: 4px;
        font-size: 14px;
        margin-right: 25px;
        cursor: pointer;
    }

    .m-live-tab-list .live-list-tab.current {
        color: #fff;
        background: #FF3F29;
    }

    .m-live-tab-list .live-list-tabs {
        margin-left: -5px;
        padding-bottom: 20px;
        font-size: 0;
        line-height: 19px;
    }

    .m-live-tab-list {
        background: #fff;
    }

    .m-breadcrumbBox .navcrumb-item>a {
        vertical-align: middle;
        font-size: 14px;
    }

    .m-breadcrumbBox .navcrumb-item:last-child a {
        cursor: default;
        color: #999;
    }

    .m-breadcrumbBox .arrow {
        display: inline-block;
        width: 6px;
        height: 10px;
        background: url(//nos.netease.com/test-edu-image/C9F43C8E56FF6C953BF9ECA24368BA15.png) no-repeat;
        background-size: 6px 10px;
        margin: 0 10px;
        vertical-align: middle;
    }

    .m-breadcrumbBox .navcrumb-item {
        display: inline-block;
        height: 20px;
        line-height: 20px;
        font-size: 0;
    }

    .m-breadcrumbBox .navcrumb-item a {
        color: #666;
    }

    .m-breadcrumbBox .navcrumb-item>a {
        vertical-align: middle;
        font-size: 14px;
    }

    .m-breadcrumbBox .navcrumb-item {
        display: inline-block;
        height: 20px;
        line-height: 20px;
        font-size: 0;
    }

    .g-doc,
    .g-wrap,
    .g-flow,
    .g-all {
        width: 1205px;
        margin: 0 auto;
        text-align: left;
    }

    .f-cb:after,
    .f-cbli li:after {
        display: block;
        clear: both;
        visibility: hidden;
        height: 0;
        overflow: hidden;
        content: ".";
    }

    .g-mn2 {
        float: left;
        width: 100%;
    }

    .m-breadcrumbBox {
        background-color: transparent;
        color: #666;
        font-size: 0;
        padding: 20px 0 20px 0;
    }

    .m-breadcrumbBox {
        background: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/train/liveClassroom.vue